import { mergeStyles } from '@cian/utils';
import React, { FC } from 'react';

import styles from './FiltersTabs.css';

export interface IFiltersTabsProps {
  items: IFiltersTabProps[];
}

export interface IFiltersTabProps {
  label: string;
  url?: string;
  isSelected?: Boolean;
  clickHandler?(event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void;
  target?: string;
}

export const FiltersTabs: FC<IFiltersTabsProps> = ({ items }) => {
  return (
    <ul className={styles['list']} data-mark="FiltersTabs">
      {items.map(({ label, isSelected, url, clickHandler, target }) => (
        <li
          key={`item_${label}`}
          {...mergeStyles(styles['list-element'], isSelected && styles['list-element--active'])}
        >
          {url ? (
            <a href={url} target={target} className={styles['link-element']}>
              {label}
            </a>
          ) : (
            <button onClick={clickHandler} className={styles['button-element']}>
              {label}
            </button>
          )}
        </li>
      ))}
    </ul>
  );
};
